import { useEffect, useState } from 'react'
import classNames from 'classnames';

function App() {

  const [mainLoader, setMainLoader] = useState(true);
  const [resources, setResources] = useState([]);
  const [resourcesInc, setResourcesInc] = useState([]);
  const [markets, setMarkets] = useState([]);
  const newsCats = [
    {name: "Most recent", tid: '-1'},
    {name: "Events", tid: '2901'},
    {name: "In the News", tid: '511'},
    {name: "News Releases", tid: '516'},
    {name: "People News", tid: '2616'}
  ];
  const [filters, setFilters] = useState({
    markets: false,
    newsCats: '-1'
  });
  const [activeChildren, setActiveChildren] = useState(false);
  const [newsCatsDropdown, setNewsCatsDropdown] = useState(true);
  const [marketsDropdown, setMarketsDropdown] = useState(false);
  const [animateMarket, setAnimateMarket] = useState(false);
  const [refreshResultsKey, setRefreshResultsKey] = useState(Math.random());
  
  const domain = 'https://www.smithgroup.com/';

  const getResources = (ctype) => {

    const uniqBy = (a, key) => {
      var seen = {};
      return a.filter(function(item) {
          var k = key(item);
          return seen.hasOwnProperty(k) ? false : (seen[k] = true);
      })
    }

    fetch(`${domain}/content/${ctype}/all`).then(response => {
      if(response.error) {
        console.error(response.error);
      } else {
        return response.json();
      }}).then(response => {
        // Remove duplicates (Drupal bug)
        let uniq = uniqBy(response, JSON.stringify);
        setMainLoader(false);
        setResources(uniq);
    })
  }

  const getMarkets = (ctype) => {

    fetch(`${domain}/json/markets/${ctype}`).then(response => {
      
      if(response.error) {
        console.error(response.error);
      } else {
        return response.json();
      }}).then(response => {
        response.forEach(market => {
          if(market.parent_target_id) {
            for (const parent of response) {
              if (parent.name.replace(/&amp;/g, "&") === market.parent_target_id.replace(/&amp;/g, "&")) {
                if(parent.children) {
                  parent.children.push(market)
    
                } else {
                  parent.children = [];
                  parent.children.push(market);
    
                }
              }
            }  
          }
        })
        setMarkets(response)
    })
  }


  // Handlers

  const handleNewsCatsFilter = (newsCat) => {
    setMarketsDropdown(false);
    setActiveChildren(false);
    setFilters({newsCats: newsCat.tid, markets: false});
    setRefreshResultsKey(Math.random());

    if(window.innerWidth <= 767)
      scrollToView();
  }

  const handleMarketFilter = (market, children = false) => {
    if(market.parent_target_id == "") {
      setNewsCatsDropdown(false);
      //setServicesDropdown(false);
      setAnimateMarket(market.tid);
    }
    setFilters({newsCats: false, markets: market.tid});
    setRefreshResultsKey(Math.random());
    
    if(children)
      setActiveChildren({parent: market, children});
    else if(market.parent_target_id == '' && !children)
      setActiveChildren(false);
  
    if(window.innerWidth <= 767)
      scrollToView(850);
    
  }

  const scrollToView = (pxs) => {
    window.scrollTo({
      top: pxs,
      behavior: 'smooth',
    });
  };


  useEffect(() => {
    getResources('news_article_page');
    //getServices();
    getMarkets('news_article_page');
  }, [])

  return (
    <div className="App layout layout--regular layout--remove-padding layout--clearfix">
      <header className="App-header">
        <h1 className="page-title resources-page-title">NEWS</h1>
        <div className="intro-text">
          <div style={{width: '100%'}} className="layout layout--regular layout--small-spacing layout--clearfix with-rule">
            <div className="col col--left col--regular-5 col--stacked wysiwyg wysiwyg--callout">
              <h3>Media Links &amp; Resources</h3>
              <p><a href="https://www.smithgroup.com/company-fact-sheet">Company Fact Sheet</a></p>
            </div>
            <div className="col col--right col--regular-14">
              <h3 className="text-subtitle">Media Contacts</h3>
              <figure role="group" className="col col--6-5-of-14 col--left contact-teaser wysiwyg wysiwyg--contact-teaser">
              <div className="contact-teaser__image"> 
                <a href="/people/dave-whitman">
                  <img srcset="/sites/default/files/styles/contact_teaser_desktop_1x/public/2024-11/Whitman_Dave_website_headshot.jpg?h=33c22240&amp;itok=yT9UzyLK 1x, /sites/default/files/styles/contact_teaser_desktop_2x/public/2024-11/Whitman_Dave_website_headshot.jpg?h=33c22240&amp;itok=954CG1Bn 2x, /sites/default/files/styles/contact_teaser_desktop_3x/public/2024-11/Whitman_Dave_website_headshot.jpg?h=33c22240&amp;itok=D4pEcsj9 3x" src="/sites/default/files/styles/contact_teaser_desktop_1x/public/2024-11/Whitman_Dave_website_headshot.jpg?h=33c22240&amp;itok=yT9UzyLK" alt="Dave Whitman, Senior Principal, Communications Director" typeof="foaf:Image" />
                </a>
              </div>
              <figcaption className="contact-teaser__info break-word">
                  <p>
                    <strong>
                      <a href="/people/dave-whitman">
                        <span>Dave Whitman</span>
                      </a>
                    </strong>
                    <br />
                    <span> Senior Principal, Communications Director</span>
                  </p>
                  <p>
                    <span>
                    <a href="tel:%28313%29442-8226">(313) 442-8226</a></span> 
                    <br />
                    <span>
                      <a href="mailto:dave.whitman@smithgroup.com" className="spamspan">dave.whitman@smithgroup.com</a>
                    </span>
                  </p>
                </figcaption> 
              </figure>
            </div>
          </div>
        </div>
      </header>

      <section className="app-menu col col--left">
        <h5 className="filter-header">FILTER BY</h5>

        <h2 className="filter-parent" onClick={()=>{setNewsCatsDropdown(!newsCatsDropdown); setMarketsDropdown(false); }}>NEWS CATEGORIES
          {
            newsCatsDropdown ?
            <span className="arrow on"></span>
            :
            <span className="arrow off"></span>
          }
        </h2>
        {
          <div className="filter-container">
            <ul className={classNames('filter-inner', newsCatsDropdown && 'on')}>
            {
              newsCats.map((item, idx) => {
                return (
                    filters.newsCats === item.tid ?
                    <li key={idx} className="active" onClick={e => handleNewsCatsFilter(item)}>{item.name}</li>
                    :
                    <li key={idx} onClick={e => handleNewsCatsFilter(item)}>{item.name}</li>
                )
              })
            }
            </ul>
          </div>
        }
        <h2 className="filter-parent" onClick={()=>{setMarketsDropdown(!marketsDropdown); setNewsCatsDropdown(false);}}>MARKETS 
          {
            <span className={classNames('arrow', marketsDropdown && 'on')}></span>
          }
        </h2>
          <div className="filter-container">
            <ul className={classNames('filter-inner', marketsDropdown && 'on')}>
              {
                markets.map((item, idx) => {
                  let activeFam = [item.tid];
                  if(item.children) {
                    activeFam = item.children.reduce((acc, curr) => {
                      const ret = acc.concat([curr.tid]);
                      return ret;
                    }, [item.tid]);
                  }
                  if(item.parent_target_id === "") {
                    if(item.children) {
                      activeFam = item.children.reduce((acc, curr) => {
                        const ret = acc.concat([curr.tid]);
                        return ret;
                      }, [item.tid]);
                      
                      return (
                        activeFam.includes(filters.markets) ?
                        <>
                          <li key={idx} className="active" onClick={e => handleMarketFilter(item, item.children)}>{item.name.replace(/&amp;/g, "&")}</li>
                            {/* <ul className="filter-inner-2">
                              {
                                item.children.map((child, idx) => {
                                  return(
                                      filters.markets === child.tid ?
                                      <li key={idx} className="active" onClick={e => handleMarketFilter(child)}>{child.name}</li>
                                      :
                                      <li key={idx} onClick={e => handleMarketFilter(child)}>{child.name}</li>
                                  )
                                })
                              }
                            </ul> */}
                        </>
                        :
                        <li key={idx} onClick={e => handleMarketFilter(item, item.children)}>{item.name.replace(/&amp;/g, "&")}</li>
                      )
                    } else {
                      return (
                          filters.markets == item.tid ?
                          <li key={idx} className="active" onClick={e => handleMarketFilter(item)}>{item.name}</li>
                          :
                          <li key={idx} onClick={e => handleMarketFilter(item)}>{item.name}</li>                      
                      )
                    }
                  }
                })
              }
            </ul>
          </div>
      </section>
              
      <section className="app-main col col--left">
        <section className="top-menu">
          {
            activeChildren &&
            <h2 className="sub-mkt-title">Browse {activeChildren.parent.name.replace(/&amp;/g, "&")} sub-markets</h2>
          }
          <ul className="filter-inner-2">
          {
            activeChildren &&
            activeChildren.children.map((child, idx) => 
              (
                filters.markets === child.tid ?
                <li key={idx} className="active" onClick={e => handleMarketFilter(child)}>{child.name.replace(/&amp;/g, "&")}</li>
                :
                <li key={idx} onClick={e => handleMarketFilter(child)}>{child.name.replace(/&amp;/g, "&")}</li>
              ))
          }
          </ul>
        </section>
        {
          mainLoader ?
          <span className="loader spinner-border"></span>
          :
          <div key={refreshResultsKey} className="row resources">
          {
            resources &&
            resources.map((item, idx) => {
              if(
                  filters.markets && item.field_markets.includes(filters.markets) ||
                  filters.newsCats && item.field_news_categories.includes(filters.newsCats) ||
                  !filters.markets && filters.newsCats == '-1'
                  ) {
                const imgUrl = item.field_key_image;
                return (
                  <article key={idx} className="tile col-3 tile-fade" markets={item.markets} >
                    <a target="_blank" href={`https://www.smithgroup.com${item.view_node}`}>
                      <img alt="img" src={`https://www.smithgroup.com${imgUrl}`} />
                      <p className="footer">{item.title}</p>
                    </a>
                  </article>
                )
              }
            })
          }
          </div>
        }
        {/* <p className="load-more" onClick={() => getResources('project_detail_page')}>Load more</p> */}
      </section>
    </div>
  );
}

export default App;
